export const styles = () => ({
  root: {
    height: 200,
    width: '100%',
  },
});
